import useQuery from './useQuery';

const useReturnUrl = (defaultUrl: string = '/') => {
  const query = useQuery();
  const returnUrl = query.get('return') ?? defaultUrl;
  return returnUrl;
};

export default useReturnUrl;
